/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 */

import './crs/Proj';
import './crs/Baidu09';
//
import Provider from './Provider';
//
import FeatureLayer from './layer/FeatureLayer';
//
import lonlats from './utils/LonLats';
//
let { Action, isArray, assign: $assign } = T;
let { Map, Control, CRS } = L;
let { Scale } = Control;
/**
 * 
 * 计划改成重写的机制
 */
export default class DMap extends Action {
  /** 
   * 平台名称
   */
  static platform = 'leaflet';
  /**
   * 通用图层类
   */
  static Layer = FeatureLayer;
  /**
   * 
   */
  _layers = [];
  /**
   * 
   */
  map;
  /**
   * 
   */
  provider;
  /**
   * 初始化地图
   * @param options 
   * @param node 
   */
  constructor(node, options) {
    super();
    options = $assign({
      doubleClickZoom: false,
      zoomControl: false,
      attributionControl: false,
      preferCanvas: true
    }, options);
    options.crs = CRS[options.crs] || options.crs || L.CRS.EPSG3857; //可以为空，Map初始化时会默认用EPSG3857
    options.center = lonlats(options.center);
    //
    node.style.cursor = 'default';
    //
    let that = this;
    let map = that.map = new Map(node, options);
    that.el = node;
    that.provider = new Provider().addTo(map);
    if (options.provider) that.provider.addLayers(options);
    options.showCoordinates && that.showCoordinates();
    options.showHawkeyeMap && that.showHawkeyeMap();
    options.showScale && new Scale().addTo(map);
    //
    that._addEvents();
    that._addRenderers();
  }
  /**
   * 
   */
  addLayer(layer) {
    let { _layers } = this;
    if (!_layers.includes(layer)) {
      _layers.push(layer);
    }
  }
  /**
   * 
   */
  layer(options) {
    return new FeatureLayer(options).addTo(this);
  }
  // 
  // tile : https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer
  // export : https://services.arcgisonline.com/arcgis/rest/services/Specialty/Soil_Survey_Map/MapServer
  // featurelayer https://services.arcgis.com/rOo16HdIMeOBI4Mb/arcgis/rest/services/Heritage_Trees_Portland/FeatureServer/0
  esri = fn => {
    //
    require.ensure([], () => {
      fn(require('esri-leaflet'));
    }, 'esri-leaflet');
  }
  /**
   * wmts 服务图层
   */
  // addWMTSLayer = (url, options) => new WMTSLayer(url, options).addTo(this.map)
  /**
   * 设置地图图源
   */
  setProvider(options) {
    let layers = this.provider.updateLayers(options);
    this.do('provider-change');
    return layers;
  }
  /**
   * 
   * @param {*} options 
   */
  addProvider(options) {
    let layers = this.provider.addLayers(options);
    this.do('provider-change');
    return layers;
  }
  /**
   * 设置地图级别
   * @param center
   * @param zoom
   * @param {animate?: boolean,duration?: number,easeLinearity?: number,noMoveStart?: boolean} options
   */
  setView(center, zoom, options) {
    let { map } = this;
    let size = 320;
    let timerid = this.timerid = +T.stamp;
    //
    center = lonlats(center);
    map.setView(center, zoom, options);
    //
    let rect = this.el.getBoundingClientRect();
    let focalizer = this._focalizer = this._focalizer || T.create('i', 'focalizer dol dol-screen', document.body);
    let { style } = focalizer;
    style.display = '';
    //
    let count = 3;
    let animate = () => {
      if (timerid !== this.timerid) return;
      if ((size -= 12) > 12) {
        let c = map.latLngToContainerPoint(center);
        style.fontSize = size + 'px';
        style.left = (rect.left + c.x - size * 0.5) + 'px';
        style.top = (rect.top + c.y - size * 0.5) + 'px';
        setTimeout(animate, 28);
      } else if (count < 0) {
        style.display = 'none';
      } else {
        size += 48;
        count--;
        setTimeout(animate, 100);
      }
    }
    animate();
  }
  /**
   * 最佳显示视野
   * @paths 经纬度数组 or path 图元
   */
  setExtent(paths) {
    return this.map.fitBounds(isArray(paths) ? lonlats(paths, (isArray(paths[0][0])) ? 2 : 1) : paths.getBounds());
  }
  /**
   * 
   * @param {*} center 
   * @param {*} zoom 
   * @param {*} options 
   */
  flyTo(center, zoom, options) {
    this.map.flyTo(lonlats(center), zoom, options)
  }
  /**
   * 移动点图
   * @param point
   */
  panBy(point) {
    //
    this.map.panBy(point);
  }
  /**
   * 
   * @param center 
   * @param zoom 
   */
  setCenterZoom(center, zoom, options) {
    if (isArray(center)) {
      center = [center[1], center[0]];
    }
    if (zoom === void 0) {
      this.map.panTo(center);
    } else {
      this.map.setView(center, zoom, options);
    }
  }
  /**
   * 设置层级
   * @param zoom
   */
  setZoom(zoom) {
    this.map.setZoom(zoom);
  }
  /**
   * 缩放
   */
  zoomBy(by) {
    this.map.zoomIn(by);
  }
  /**
   * 获取中心点
   */
  getCenter() {
    return this.map.getCenter();
  }
  /**
   * 获取地图等级
   */
  getZoom() {
    return this.map.getZoom()
  }
  /**
   * 获取地图;最小,最大]等级
   */
  getZooms() {
    return [this.map.getMinZoom(), this.map.getMaxZoom()];
  }
  /**
   * 绘制
   * @param {} options 
   */
  draw(options) {
    return new Promise((resolve) => {
      require.ensure([], () => {
        resolve((this.tool = this.tool || new (require('@/plugins/DrawLayer').default)().addTo(this)).change(options));
      }, 'drawLayer')
    })
  }
  /**
   * 显示坐标控件
   */
  showCoordinates() {
    require.ensure([], () => {
      let { Coordinates } = require('@/plugins/Widgets');
      new Coordinates().addTo(this.map);
    }, 'widgets')
  }
  /**
   * 显示鹰眼图
   */
  showHawkeyeMap(options) {
    require.ensure([], () => {
      let { HawkeyeMap } = require('@/plugins/Widgets');
      new HawkeyeMap(options).addTo(this.map);
    }, 'widgets')
  }
  /**
   * 
   */
  _addEvents() {
    let { map } = this;
    map.on('zoomend moveend', function () {
      let zoom = map.getZoom();
      let bounds = map.getBounds();
      map.eachLayer(layer => {
        //
        let tooltip = layer.getTooltip();
        if (tooltip) {
          let { options } = tooltip;
          if ('zoom' in options) {
            let toOpen = options.zoom < zoom && bounds.contains(layer._latlng);
            let isOpen = tooltip.isOpen();
            if (toOpen) {
              !isOpen && !layer._hideTooltip && layer.openTooltip();
            } else {
              map.removeLayer(tooltip);
            }
          }
        }
      });
    })
  }
  /**
   * 
   */
  _addRenderers() {
    let { map } = this;
    map.__glow = new L.Glow().addTo(map);
    map.__animate = new L.Animate().addTo(map);
  }
  /**
   * 测量距离
   * @param p1 
   * @param p2
   */
  distance(p1, p2) {
    return this.map.distance(lonlats(p1), lonlats(p2))
  }
  /**
   * 设置区域遮罩层
   */
  setMask(coordinates, options) {
    this.mask && this.mask.remove();
    return coordinates && (this.mask = L.polygon(lonlats(coordinates, isArray(coordinates[0][0]) ? 2 : 1), $assign({
      interactive: false,
      renderer: new L.Mask({ pane: 'tilePane' }),
      fillOpacity: 1,
      weight: 2,
      color: '#042847',
      shadowBlur: 5,
      shadowColor: '#042847'
    }, options)).addTo(this.map));
  }
  /**
   * 常用于地图容器宽度高度改变之后。
   */
  resize() {
    this.map.invalidateSize();
  }
  /**
   * 
   */
  layerPointToLatLng(point) {
    return this.map.layerPointToLatLng(point);
  }
  /**
   * 
   */
  latLngToLayerPoint(point) {
    return this.map.latLngToLayerPoint(point);
  }
}


// WEBPACK FOOTER //
// ./src/Map.js